import MessageCTAs from "./MessageCTAs";
import InternalRating from "../../custom/HM/InternalRating";
import StarRating from "../../custom/HM/StarRating";

export default function HotelMessageTemplate({
  template,
  index,
  assistantId,
  threadId,
  isMobile,
}: any) {
  return (
    <div className="message-template" key={index}>
      <div className="message-template-title">
        {index + 1 + ". "}
        {template.title}
        <StarRating stars={template.stars} />
      </div>
      <div className="message-template-subtitle">{template.sub_title}</div>
      <img
        alt="Hotel"
        className="message-template-image-main"
        src={template.placeholder_image}
      ></img>
      <div className="message-template-location">📍 {template.location}</div>
      {template.internal_rating && (
        <InternalRating rating={template.internal_rating} />
      )}
      <ul className="message-template-details">
        {template.details.map((detail: any, detailIndex: any) => (
          <li key={detailIndex}>{detail}</li>
        ))}
      </ul>
      <MessageCTAs
        assistantId={assistantId}
        isMobile={isMobile}
        template={template}
        threadId={threadId}
      />
    </div>
  );
}
